<template>
  <slot name="activator" :onClick="handleLogout">
    <div class="logout-button-container">
      <EgovButton
        appendIcon="ri-logout-box-r-line"
        backgroundColor="var(--kds-error)"
        :disabled="false"
        label="Log Out"
        variant="filled"
        @click="handleLogout"
      />
    </div>
  </slot>

  <EgovModal
    v-model="showLogoutModal"
    icon="ri-error-warning-line"
    title="Confirm Log Out"
    size="medium"
    :primaryCta="{ label: 'Log Out', variant: 'filled', onClick: onLogoutClick, backgroundColor: 'var(--kds-error)' }"
    :secondaryCta="{ label: 'Go Back', variant: 'text', onClick: () => (showLogoutModal = false) }"
  >
    <template #content>
      <p class="modal-body-text" v-if="text1" v-html="text1" />
      <p class="font-weight-bold modal-body-text" v-if="text2" v-html="text2" />
      <p class="modal-body-text" v-if="text3" v-html="text3" />
    </template>
  </EgovModal>
</template>

<script setup>
import EgovButton from '@/components/common/EgovButton.vue'
import { ref } from 'vue'
import EgovModal from '@/components/common/EgovModal.vue'
import { useUserLogin } from '@/stores/userLogin'

defineProps({
  text1: { type: String, default: null },
  text2: { type: String, default: null },
  text3: { type: String, default: null },
})
const showLogoutModal = ref(false)
const userLogin = useUserLogin()

function handleLogout() {
  showLogoutModal.value = true
}

const onLogoutClick = () => {
  showLogoutModal.value = false
  userLogin.logout()
}

</script>

<style scoped lang="scss">
.modal-body-text {
  font-size: 0.875rem;
  line-height: 1.5;
  color: var(--kds-on-surface);

  & + & {
    margin-top: 16px;
  }
}
</style>
